import { ThemeConfig } from 'antd';

export enum Theme {
  Dark = 'dark',
  Light = 'light',
  Default = Theme.Light,
}

export enum ThemeAlgorithm {
  DarkAlgorithm = 'darkAlgorithm',
  DefaultAlgorithm = 'defaultAlgorithm',
}

export type ThemeConfigurationType = ThemeConfig & {
  cssVars: Record<string, string>;
};
